import {
	GetLoggedInUserRolesRequest,
	GetLoggedInUserRolesResponse,
	GetModulesRequest,
	GetModulesResponse,
	GetRoleModulesMappingRequest,
	GetRoleModulesMappingResponse,
	GetRolesRequest,
	GetRolesResponse,
	UpdateRoleModulePrivilegesRequest,
	GetModulePrivilegeMappingsRequest,
	GetModulePrivilegeMappingsResponse,
	GetRolePrivilegeMappingRequest,
	GetRolePrivilegeMappingResponse,
	AddOrUpdateRoleModuleMappingRequest,
	AddOrUpdateRolePrivilegeRequest,
} from '../shared/RoleBasedTypes';
import { BooleanValue } from '../shared/VolunteerApplicationServiceTypes';
import { volunteerServiceClient } from './HTTPClient';

export const getRoleModulesMapping = async (
	request: GetRoleModulesMappingRequest
): Promise<GetRoleModulesMappingResponse> => {
	const response =
		await volunteerServiceClient.post<GetRoleModulesMappingResponse>(
			'getRoleModulesMapping',
			request
		);
	return response.data;
};

export const getLoggedInUserRoles = async (
	request: GetLoggedInUserRolesRequest
): Promise<GetLoggedInUserRolesResponse> => {
	const response =
		await volunteerServiceClient.post<GetLoggedInUserRolesResponse>(
			'getLoggedInUserRoles',
			request
		);
	return response.data;
};

export const getRoles = async (
	request: GetRolesRequest
): Promise<GetRolesResponse> => {
	const response = await volunteerServiceClient.post<GetRolesResponse>(
		'getRoles',
		request
	);
	return response.data;
};

export const getModules = async (
	request: GetModulesRequest
): Promise<GetModulesResponse> => {
	const response = await volunteerServiceClient.post<GetModulesResponse>(
		'getModules',
		request
	);
	return response.data;
};

export const getRolePrivilegeMappings = async (
	request: GetRolePrivilegeMappingRequest
): Promise<GetRolePrivilegeMappingResponse> => {
	const response =
		await volunteerServiceClient.post<GetRolePrivilegeMappingResponse>(
			'getRolePrivilegeMappings',
			request
		);
	return response.data;
};

export const updateRoleModulePrivileges = async (
	request: UpdateRoleModulePrivilegesRequest
): Promise<BooleanValue> => {
	const response = await volunteerServiceClient.post<BooleanValue>(
		'updateRoleModulePrivileges',
		request
	);
	return response.data;
};

export const getModulePrivilegeMappings = async (
	request: GetModulePrivilegeMappingsRequest
): Promise<GetModulePrivilegeMappingsResponse> => {
	const response =
		await volunteerServiceClient.post<GetModulePrivilegeMappingsResponse>(
			'getModulePrivilegeMappings',
			request
		);
	return response.data;
};

export const addOrUpdateRoleModuleMapping = async (
	request: AddOrUpdateRoleModuleMappingRequest
): Promise<BooleanValue> => {
	const response = await volunteerServiceClient.post<BooleanValue>(
		'addOrUpdateRoleModuleMapping',
		request
	);
	return response.data;
};

export const addOrUpdateRolePrivilegeMapping = async (
	request: AddOrUpdateRolePrivilegeRequest
): Promise<BooleanValue> => {
	const response = await volunteerServiceClient.post<BooleanValue>(
		'addOrUpdateRolePrivilegeMapping',
		request
	);
	return response.data;
};
